import React, { useState, useEffect } from "react";

// Helpers
import { ScrollDisable } from "../../helpers/ScrollLock";

// Custom components
import { DualRowItem, RegularField } from "../InputFields/InputFields";
import DataTable from "../DataTable/DataTable";

// API
import useAxios from "../../hooks/useAxios";
import jsonFormatAuth from "../../apis/jsonFormatAuth";

const RapidEntryOptions = (props) => {
  const {
    saveEntryFunction,
    setDeleteOpen,

    rapidPatientUniqueId,
    setRapidPatientUniqueId,
    rapidPatientFullName,
    setRapidPatientFullName,
    selectedExistingPatientId,
    setSelectedExistingPatientId,
    setRapidEntryAction,
    // Field warnings.
    rapidPatientUniqueIdWarning,
    rapidPatientFullNameWarning,
  } = props;

  //delete, save_to_new, save_to_existing
  const [selectedTab, setSelectedTab] = useState("delete");

  const handleTabSelection = (tabAddress) => {
    setSelectedTab(tabAddress);
    setRapidEntryAction(tabAddress);
    setRapidPatientUniqueId("");
    setSelectedExistingPatientId("");
  };

  // API START
  const { response, axiosFetch } = useAxios();
  const [patientData, setPatientData] = useState([]);
  const [userTags, setUserTags] = useState([]);

  const getData = () => {
    axiosFetch({
      axiosInstance: jsonFormatAuth(),
      method: "GET",
      url: "patients/patient_menu",
      sendSignal: false,
      requestConfig: {},
    });
  };

  useEffect(() => {
    // Obtain data from API on initial page load.
    getData();
  }, []);

  // RESPONSE Detection
  useEffect(() => {
    // Patients data received.
    if (response) {
      if (response?.action_code === "patients_sent") {
        setPatientData(response?.payload?.patients_data || []);
        setUserTags(response?.payload?.tags || []);
      }
    }
  }, [response]);
  // API END

  const MenuTabButton = ({ prompt, tabName, selectedTab }) => {
    return (
      <button
        onClick={() => {
          handleTabSelection(tabName);
        }}
        className={`flex flex-1 flex-row items-center justify-center w-full p-4
                   rounded-lg border border-1 border-neutral-300
                   text-xl font-medium text-neutral-800

                   ${
                     tabName === selectedTab
                       ? "bg-cyan-100 border-neutral-800"
                       : ""
                   }
                  `}
      >
        {prompt}
      </button>
    );
  };

  const DEPLOYMENT_TYPE = process.env.REACT_APP_DEPLOYMENT_TYPE;
  const disableFields = DEPLOYMENT_TYPE === "demo";

  return (
    <div className="flex flex-col items-center justify-center w-full h-full Xbg-red-500">
      <div className="flex flex-col md:flex-row items-center justify-center w-full space-y-2 md:space-y-0 md:space-x-2 Xbg-green-500">
        <MenuTabButton
          prompt={"Delete"}
          tabName={"delete"}
          selectedTab={selectedTab}
        />

        <MenuTabButton
          prompt={"Save to New"}
          tabName={"save_to_new"}
          selectedTab={selectedTab}
        />

        <MenuTabButton
          prompt={"Save to Existing"}
          tabName={"save_to_existing"}
          selectedTab={selectedTab}
        />
      </div>
      {selectedTab === "delete" && (
        <div className="flex flex-row items-center justify-center w-full pb-6">
          <button
            onClick={() => {
              setDeleteOpen(true);
              ScrollDisable();
            }}
            className={`flex flex-1 flex-row items-center justify-center w-full mt-6 p-5
                        bg-red-50 hover:bg-red-100 active:bg-red-200
                        rounded-lg border border-1 border-neutral-300 hover:border-neutral-500
                        text-2xl font-medium text-neutral-800

                  `}
          >
            Delete Entry
          </button>
        </div>
      )}
      {selectedTab === "save_to_new" && (
        <div className="flex flex-col items-center justify-center w-full pb-6">
          <DualRowItem
            leftChild={
              <RegularField
                value={rapidPatientUniqueId}
                setFunction={setRapidPatientUniqueId}
                fieldWarning={rapidPatientUniqueIdWarning}
                fieldDisabled={false}
                fieldLabel={"Unique Patient ID"}
                placeholderText={"e.g., 0112358 (required)"}
                fieldType="text"
                takeFullWidth={true}
              />
            }
            rightChild={
              <RegularField
                value={rapidPatientFullName}
                setFunction={setRapidPatientFullName}
                fieldWarning={rapidPatientFullNameWarning}
                fieldDisabled={disableFields}
                fieldLabel={"Full Name"}
                placeholderText={"e.g., John Smith (optional)"}
                fieldType="text"
                takeFullWidth={true}
              />
            }
          />

          <button
            onClick={() => {
              saveEntryFunction();
            }}
            className={`flex flex-1 flex-row items-center justify-center w-full mt-6 p-5
                        bg-green-50 hover:bg-green-100 active:bg-green-200
                        rounded-lg border border-1 border-neutral-300 hover:border-neutral-500
                        text-2xl font-medium text-neutral-800

                  `}
          >
            Save Entry
          </button>
        </div>
      )}
      {selectedTab === "save_to_existing" && (
        <div className="flex flex-col items-center justify-center w-full pt-6 pb-6">
          <DataTable
            data={patientData}
            dataTags={userTags}
            rowType={"patient"}
            showFilter={true}
            showPageNav={true}
            additionalArgs={{
              isRapidEntry: true,
              selectedExistingPatientId,
              setSelectedExistingPatientId,
            }}
          />
          <button
            onClick={() => {
              saveEntryFunction();
            }}
            className={`flex flex-1 flex-row items-center justify-center w-full mt-6 p-5
                        bg-green-50 hover:bg-green-100 active:bg-green-200
                        rounded-lg border border-1 border-neutral-300 hover:border-neutral-500
                        text-2xl font-medium text-neutral-800

                  `}
          >
            Save Entry
          </button>
        </div>
      )}
    </div>
  );
};

export default RapidEntryOptions;
